import Breadcrumb from './breadcrumb';
import BreadcrumbItem from './breadcrumb-item';
import Button from './button';
import Cascader from './cascader';
import Checkbox from './checkbox';
import CheckboxGroup from './checkbox-group';
import Col from './col';
import DatePicker from './date-picker';
import Dropdown from './dropdown';
import Form from './form';
import FormItem from './form-item';
import Input from './input';
import InputNumber from './input-number';
import Layout from './layout';
import LayoutContent from './layout-content';
import LayoutFooter from './layout-footer';
import LayoutHeader from './layout-header';
import LayoutSider from './layout-sider';
import Menu from './menu';
import MenuItem from './menu-item';
import Message from './message';
import Modal from './modal';
import Pagination from './pagination';
import Radio from './radio';
import RadioButton from './radio-button';
import RadioGroup from './radio-group';
import RangePicker from './range-picker';
import Row from './row';
import Select from './select';
import SelectOption from './select-option';
import Space from './space';
import SubMenu from './sub-menu';
import Switch from './switch';
import TabPane from './tab-pane';
import Table from './table';
import TableColumn from './table-column';
import Tabs from './tabs';
import Textarea from './textarea';
import TimePicker from './time-picker';
import Tree from './tree';
import TreeSelect from './tree-select';
import Upload from './upload';
const version = '2.1.3';
const components = [Breadcrumb, BreadcrumbItem, Button, Cascader, Checkbox, CheckboxGroup, Col, DatePicker, Dropdown, Form, FormItem, Input, InputNumber, Layout, LayoutContent, LayoutFooter, LayoutHeader, LayoutSider, Menu, MenuItem, Message, Modal, Pagination, Radio, RadioButton, RadioGroup, RangePicker, Row, Select, SelectOption, Space, SubMenu, Switch, TabPane, Table, TableColumn, Tabs, Textarea, TimePicker, Tree, TreeSelect, Upload];
const install = function install(app) {
  components.forEach(component => {
    if ('install' in component) {
      app.use(component);
    }
  });
  return app;
};
export { Breadcrumb, BreadcrumbItem, Button, Cascader, Checkbox, CheckboxGroup, Col, DatePicker, Dropdown, Form, FormItem, Input, InputNumber, Layout, LayoutContent, LayoutFooter, LayoutHeader, LayoutSider, Menu, MenuItem, Message, Modal, Pagination, Radio, RadioButton, RadioGroup, RangePicker, Row, Select, SelectOption, Space, SubMenu, Switch, TabPane, Table, TableColumn, Tabs, Textarea, TimePicker, Tree, TreeSelect, Upload };
export default {
  version,
  install
};